module.exports = __webpack_public_path__ + "img/table-icon-wpp.784df8c4.png";